import { useEffect, useState, useRef } from "react";
import { CAR_DATA_JSON, DESTINATIONS, VEHICLE_DATA, RATE_NAMES } from "./CarData";
import { IconCar, IconInfoCircleFilled, IconX } from "@tabler/icons-react";
import { IconMapPinFilled } from "@tabler/icons-react";
import { IconCalendarEvent } from "@tabler/icons-react";
import { collection, addDoc, Timestamp, query, where, getDocs } from "firebase/firestore";
import { db } from '../firebase';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { eachDayOfInterval } from "date-fns";
import { Tabs, ConfigProvider } from 'antd';
import TermsAndConditions from '../components/TermsAndConditions';
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import { format } from "date-fns";
import emailjs from '@emailjs/browser';


Date.prototype.yyyymmdd = function() {
  let mm = this.getMonth() + 1; // getMonth() is zero-based
  let dd = this.getDate();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('-');
};

function BookCar({selectedVehicle}) {
  const [modal, setModal] = useState(false); //  class - active-modal
  const [TACmodal, setTACModal] = useState(false); //  class - active-modal
  const [processing, setProcessing] = useState(false);
  const [acceptTAC, setAcceptTAC] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [capType, setCapType] = useState('lowcap');
  const [destID, setDestID] = useState('1');
  const [orderID, setOrderID] = useState('');
  const [orderConfirmed, setorderConfirmed] = useState(false);
  const selectedCarType = selectedVehicle;
  const paypal = useRef();
  const bookform = useRef();
  
  const addBooking = async (bookingdata) => {
    setProcessing(true);
    try {
        const docRef = await addDoc(collection(db, "bookings"), {
          booking: bookingdata,    
        });

        setModal(!modal);
        const doneMsg = document.querySelector(".booking-done");
        doneMsg.style.display = "flex";
        setProcessing(false);

        console.log("Document written with ID: ", docRef.id, bookingdata);

        //form.current   e.target
        //console.log(bookform.current);

        const emaildata = {
          email: "delunaphoebe06@gmail.com", //"delunaphoebe06@gmail.com"
          booking_id: bookingdata.orderID,
          customer: lastName+", "+name,
          phone: bookingdata.phone,
          vehicle: bookingdata.carType,
          price: bookingdata.rentfee,
          total: bookingdata.totalfee,
          carwash: carwashfee,
          bookfee: bookingfee,
          date: format(pickDateTime, "MMM dd, yyyy hh:mm a")
        }

        emailjs.send('service_sw8htxn', 'template_dcvb3ve', emaildata, {
          publicKey: 'cTs2zgb83RpykvP3S',
        })
        .then(
          () => {
            console.log('SUCCESS!');
          },
          (error) => {
            console.log('FAILED...', error.text);
          },
        );

      } catch (e) {
        setModal(!modal);
        const errorMsg = document.querySelector(".booking-error");
        errorMsg.style.display = "flex";
        setProcessing(false);

        console.error("Error adding document: ", e, bookingdata);
      }
  }
  
  // booking car
  const [carType, setCarType] = useState(selectedCarType);
  const [pickUp, setPickUp] = useState("SJD Building");
  const [dropOff, setDropOff] = useState("");
  const [pickTime, setPickTime] = useState("");
  const [dropTime, setDropTime] = useState("");
  const [cityonly, setCityOnly] = useState(false);
  const [pickDateTime, setNewPickTime] = useState(new Date());
  const [dropDateTime, setNewDropTime] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [minDate, setMinDate] = useState(new Date());
  const [minEndDate, setMinEndDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [excDates, setExcDates] = useState([]);

  //console.log("carType", carType);
  //console.log("selectedVehicle", selectedVehicle);

  // modal infos
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [discountcode, setDiscount] = useState("");
  // const [address, setAddress] = useState("");
  // const [city, setCity] = useState("");
  // const [zipcode, setZipCode] = useState("");

  // taking value of modal inputs
  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };

  const handleAge = (e) => {
    setAge(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleDiscount = (e) => {
    setDiscount(e.target.value);
  };

  const handleDropDateTime = (e) => {
    //setNewDropTime(dropTime + " " + e.target.value);
    //console.log(e.toLocaleTimeString());
    setNewDropTime(new Date(dropTime + " " + e.toLocaleTimeString()));
  };

  const handlePickDateTime = (e) => {
    //setNewPickTime(pickTime + " " +e.target.value);
    //console.log(e.toLocaleTimeString());
    setNewPickTime(new Date(pickTime + " " + e.toLocaleTimeString()));
  };

  const handleHeadcount = (e) => {
    console.log("value", e.target.value);
    console.log("key", e.target.selectedOptions[0].getAttribute('data-id'));
    setCapType(e.target.value);
  }

  // const handleAddress = (e) => {
  //   setAddress(e.target.value);
  // };

  // const handleCity = (e) => {
  //   setCity(e.target.value);
  // };

  // const handleZip = (e) => {
  //   setZipCode(e.target.value);
  // };

  const openTACModal = (e) => {
    e.preventDefault();
    setTACModal(!TACmodal);
  };

  const showPayPal = () => {
    if(window.paypal) {
      console.log("createpaypal button")
      window.paypal.Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [
              {
                description: "Booking",
                amount: {
                  currency_code: "PHP",
                  value: totalfee
                }
              }
            ],
            application_context: {
              shipping_preference: 'NO_SHIPPING',
              return_url: 'https://www.beyondallreason.info/thank-you',
              cancel_url: 'https://www.beyondallreason.info/too-bad'
            }
          })
        },
        onApprove: async (data, actions) =>{
          const order = await actions.order.capture();
          console.log("onApprove", order);
          console.log('Transaction completed by ' + order.payer.name.given_name + '!');
          //setName(order.payer.name.given_name);
          //setLastName(order.payer.name.surname);
          //setEmail(order.payer.email_address);
          //setOrderID(order.id);

          const bookingdata = {
            "carType": carName,
            "orderID": order.id,
            "bookingType" : (activeTab === "1")?"Self-Drive":"Drop-Off",
            "carPlate": carPlate,
            "pickUp": pickUp,
            "dropOff": dropOff,
            "pickTime": format(pickDateTime, "MMM dd, yyyy H:mma"),
            "monthIndex" : format(pickDateTime, "MMM"),
            "yearIndex" : format(pickDateTime, "yyyy"),
            "dropTime": format(dropDateTime, "MMM dd, yyyy H:mma"),
            "cityonly": cityonly,
            "name": order.payer.name.given_name,
            "lastName": order.payer.name.surname,
            "phone": phone,
            "age": age,
            "email": order.payer.email_address,
            "discountcode": discountcode,
            "rentfee": rentfee,
            "duration": ratetype,
            "numDays": numDays,
            "owner": owner,
            "totalfee": totalfee,
            "timebooked": Timestamp.now(),
          };

          addBooking(bookingdata);
        },
        onError: (err) => {
          console.log("onError", err);
        }
      }).render(paypal.current); 
    }
  }

  // open modal when all inputs are fulfilled
  const openModal = (e) => {
    e.preventDefault();
    const errorMsg = document.querySelector(".error-message");
    const errorTxt = document.querySelector(".error-text");
    if (
      pickUp === "" ||
      (activeTab === "2" && dropOff === "") ||
      pickTime === "" ||
      (activeTab === "1" && dropTime === "") ||
      (activeTab === "1" && carType === "")
    ) {
      errorTxt.innerHTML = (pickTime === "")?"Choose a start date.":((dropTime === "")?"Choose a return date.":"All fields required!");
      errorMsg.style.display = "flex";
    } else {
      setModal(!modal);
      const modalDiv = document.querySelector(".booking-modal");
      modalDiv.scroll(0, 0);
      errorMsg.style.display = "none";

    }
  };

  // disable page scroll when modal is displayed
  useEffect(() => {
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modal]);

  const generateCode = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;    
  }
  
  const uuid = generateCode();

  // confirm modal booking
  const confirmBooking = (e) => {
    e.preventDefault();
    if(acceptTAC) {
      if(phone === "") {
        const errorMsg = document.querySelector(".res-error-message");
        const errorTxt = document.querySelector(".res-error-text");
        errorTxt.innerHTML = "Please enter your phone number.";
        errorMsg.style.display = "flex";
        return;
      }
      const bookingID = uuid.toUpperCase();
      setOrderID(bookingID);
      setorderConfirmed(true);
      //showPayPal();

      ////////////////no paypal/////////////////////////
      const bookingdata = {
        "carType": carName,
        "orderID": bookingID,
        "bookingType" : (activeTab === "1")?"Self-Drive":"Drop-Off",
        "carPlate": carPlate,
        "pickUp": pickUp,
        "dropOff": dropOff,
        "pickTime": format(pickDateTime, "MMM dd, yyyy hh:mm a"),
        "monthIndex" : format(pickDateTime, "MMM"),
        "yearIndex" : format(pickDateTime, "yyyy"),
        "dropTime": format(dropDateTime, "MMM dd, yyyy hh:mm a"),
        "cityonly": cityonly,
        "name": name,
        "lastName": lastName,
        "phone": phone,
        "age": age,
        //"email": order.payer.email_address,
        "discountcode": discountcode,
        "rentfee": rentfee,
        "duration": ratetype,
        "numDays": numDays,
        "owner": owner,
        "totalfee": totalfee,
        "timebooked": Timestamp.now(),
      };

      addBooking(bookingdata);
      ///////////////////////////////////

    } else
      alert('Please accept our terms and conditions by checking the checkbox.')
    // setModal(!modal);
    // const doneMsg = document.querySelector(".booking-done");
    // doneMsg.style.display = "flex";
  };

  const getbookeddates = async (carPlate) => {
    if(carPlate === 'Select your car type') return;
    let excludedDates = [];
    console.log("checking", carPlate);
    const bookingsRef = collection(db, "bookings");
    const q = query(bookingsRef, where("booking.carPlate", "==", carPlate));    
    const querySnapshot = await getDocs(q);    
    const newData = querySnapshot.docs.map((doc) => ({...doc.data().booking, id:doc.id }));  
    console.log(newData);
    newData.forEach((doc) => {
      console.log(doc.pickTime, doc.dropTime);
      
      try {
        let excludeDatesTemp = excludedDates.concat(eachDayOfInterval({
          start: new Date(doc.pickTime),
          end: new Date(doc.dropTime)
        }));
        excludedDates = excludeDatesTemp;
      } catch (error) {
        console.log('eachDayOfInterval error', error)
      }
      // console.log(eachDayOfInterval({
      //   start: new Date(doc.pickTime),
      //   end: new Date(doc.dropTime)
      // }));
    });
    console.log(excludedDates);
    setExcDates(excludedDates);
   }

  // taking value of booking inputs
  const handleCar = (e) => {
    getbookeddates(e.target.value);
    setCarType(e.target.value);
  };

  const handleAcceptTAC = (e) => {
    setAcceptTAC(e.target.checked);
  }

  const handleCityOnly = (e) => {
    setCityOnly(e.target.checked);
  };

  const handlePick = (e) => {
    setPickUp(e.target.value);
  };

  const handleDrop = (e) => {
    console.log("value", e.target.value)    
    console.log("key", e.target.selectedOptions[0].getAttribute('data-id'));
    setDestID(e.target.selectedOptions[0].getAttribute('data-id'));    
    if(e.target.selectedOptions[0].getAttribute('data-id').includes("1Pax")) {
      setCapType("lowcap");
    }
    setDropOff(e.target.value);
  };

  // const handlePickTime = (e) => {
  //   setPickTime(e.target.value);
  // };

  // const handleDropTime = (e) => {
  //   setDropTime(e.target.value);
  // };

  const handleStartDate = (sDate) => {
    //console.log(sDate)
    setStartDate(sDate);
    setMinEndDate(sDate);
    setPickTime(sDate.yyyymmdd());
    // setNewPickTime(sDate.yyyymmdd());
    setNewPickTime(sDate);
    handleEndDate(sDate);
  };

  const handleEndDate = (eDate) => {
    //console.log(eDate)
    setEndDate(eDate);
    setDropTime(eDate.yyyymmdd());
    // setNewDropTime(eDate.yyyymmdd());
    setNewDropTime(eDate);
  };

  const getBookingDuration = (days) => {
      switch(true) {
        case days == 0:
          return 'halfday';
        case days < 7:
          return 'daily';
        case days < 30:
          return 'weekly';
        default:
          return 'monthly';
      }    
  };

  let numDays = 1;
  if(dropTime) {
    let diffTime = Date.parse(dropTime) - Date.parse(pickTime);
    numDays = Math.round(diffTime / (1000 * 3600 * 24));
  };

  // based on value name show car img
  let imgUrl = "";
  let carName = "";
  let rentfee = 0;
  let carwashfee = 200;
  let bookingfee = 100;
  let totalfee = 0;
  let ratetype = "1 Day Within City";
  let owner = "";
  let carPlate = "";
  let carModel = "";
  if(carType && carType !== 'Select your car type') {
    imgUrl = CAR_DATA_JSON[carType]["img"];
    carName = CAR_DATA_JSON[carType]["name"];
    rentfee = CAR_DATA_JSON[carType]["price"];
    owner = CAR_DATA_JSON[carType]["owner"];
    carPlate = CAR_DATA_JSON[carType]["plate"];    
    if (numDays > 14) 
      ratetype = "More than 2 Weeks";
    else if (numDays >= 7)
      ratetype = "1-2 Weeks Rent In and Out of the City";
    else if (numDays > 1 && cityonly)
      ratetype = "More than 1 Day Within City";
    else if (numDays > 1 && !cityonly)
      ratetype = "More than 1 Day Outside City";
    else if (!cityonly)
      ratetype = "1 Day Outside City";

    //rentfee = CAR_DATA_JSON[carType]["rates"][ratetype];
    //carwashfee = CAR_DATA_JSON[carType]["carwashfee"];
    //bookingfee = CAR_DATA_JSON[carType]["adminfee"];
  }

  if(activeTab === "2") {
    let filtered = DESTINATIONS.filter((data) => {
      return data.key == destID;
    });
    console.log("destID", destID);
    console.log("filtered", filtered);
    console.log("capType", capType);
    if(destID.includes("1Pax")) {
      carwashfee = 150;
    }
    if(filtered.length > 0) {
      rentfee = filtered[0].rates[capType];
      console.log("rentfee", rentfee);
      totalfee = rentfee + (carwashfee + bookingfee);
      console.log("totalfee", totalfee);
    }
  } else {
    let filtered = VEHICLE_DATA.filter((data) => {
      return data.plate == carPlate;
    });
    console.log("carPlate", carPlate);
    console.log("filtered", filtered);
    console.log("numDays", numDays);
    console.log("getBookingDuration", getBookingDuration(numDays));
    
    if(filtered.length > 0) {      
      rentfee = filtered[0].rates[getBookingDuration(numDays)];
      carwashfee = filtered[0].carwashfee;
      bookingfee = filtered[0].adminfee;

      console.log("rentfee", rentfee);
      //totalfee = (((numDays===0)?1:numDays) * rentfee) + (carwashfee + bookingfee);
      totalfee = rentfee + (carwashfee + bookingfee);
      console.log("totalfee", totalfee);
    }
  }

  // hide message
  const hideMessage = () => {
    const doneMsg = document.querySelector(".booking-done");
    doneMsg.style.display = "none";
    const bookingerrorMsg = document.querySelector(".booking-error");
    bookingerrorMsg.style.display = "none";
    const errorMsg = document.querySelector(".error-message");
    errorMsg.style.display = "none";
    const reserrorMsg = document.querySelector(".res-error-message");
    reserrorMsg.style.display = "none";
    
  };

  const [items, setItems] = useState([
    {
      label: 'Self Drive Cars',
      key: '1',
      //children: 'Content of editable tab 1',
    },
    {
      label: 'Drop-Off Transportation',
      key: '2',
      //children: 'Content of editable tab 2',
    },
  ]);

  return (
    <>
      <section id="booking-section" className="book-section">
        {/* overlay */}
        <div
          onClick={openModal}
          className={`modal-overlay ${modal ? "active-modal" : ""}`}
        ></div>

        <div className="container">
          <div className="book-content">
            <div className="book-content__box">

              <ConfigProvider
                theme={{
                  components: {
                    Tabs: {
                      itemActiveColor:"#ffffff",
                      itemSelectedColor:"#ffffff"
                    },
                  },
                }}
              >
              <Tabs
                defaultActiveKey="1"
                type="card"
                size="large"
                style={{
                  marginBottom: 32,
                }}
                items={items}
                onChange={setActiveTab}
              />
              </ConfigProvider>

              <h2>Book a ride</h2>

              <form className="box-form">
                {
                  (activeTab === "1") &&
                  <div className="box-form__car-type">
                    <label>
                      <IconCar className="input-icon" /> &nbsp; Vehicle <b>*</b>
                    </label>
                    <select value={carType} onChange={handleCar}>
                      <option>Select your vehicle</option>
                      <option value="ASDF 7264">Nissan Navara</option>
                      <option value="ASDF 7263">Toyota Veloz</option>
                      <option value="ASDF 7262">Suzuki XL7</option>
                      <option value="ASDF 7261">Honda Beat</option>
                    </select>
                  </div>
                }

                <div className="box-form__car-type">
                  <label>
                    <IconMapPinFilled className="input-icon" /> &nbsp; Pick-up{" "}
                    <b>*</b>
                  </label>
                  <input type="text" className="bookinginput" value={pickUp} onChange={handlePick}/>
                  {/* <select value={pickUp} onChange={handlePick}>
                    <option>Select pick up location</option>
                    <option>SM City Puerto Princesa</option>
                    <option>Robinson's Place Palawan</option>
                    <option>Airport</option>
                    <option>Hue Hotel</option> 
                    <option>SJD Building</option>
                  </select> */}
                </div>

                {
                  (activeTab === "2") &&     
                  <>     
                  <div className="box-form__car-type">
                    <label>
                      <IconMapPinFilled className="input-icon" /> &nbsp; Drop-of{" "}
                      <b>*</b>
                    </label>
                    <select value={dropOff} onChange={handleDrop}>
                      <option>Select drop off location</option>
                      {DESTINATIONS.map((d)=>{
                        return(<option key={d.key} data-id={d.key}>{d.name}</option>);
                      })}
                    </select>
                  </div>

                  {(!destID.includes("1Pax")) &&
                  <div className="box-form__car-type">
                    <label>
                      <IconMapPinFilled className="input-icon" /> &nbsp; Headcount{" "}
                      <b>*</b>
                    </label>
                    <select value={capType} onChange={handleHeadcount}>
                      <option>Select number of passengers</option>
                      {RATE_NAMES.map((d)=>{
                        return(<option key={d.id} data-id={d.id}>{d.name}</option>);
                      })}
                    </select>
                  </div>}
                  </>      
                }

                <div className="box-form__car-time">
                  <label htmlFor="picktime">
                    <IconCalendarEvent className="input-icon" /> &nbsp; {(activeTab === "2")? "Pick-up" : "Start"} Date{" "}
                    <b>*</b>
                  </label>

                  {/* <input
                    id="picktime"
                    value={pickTime}
                    onChange={handlePickTime}
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                  ></input> */}                  
                  <DatePicker 
                    id="picktime"
                    selected={startDate}
                    onChange={handleStartDate}
                    minDate={minDate}
                    // dateFormat="MMMM d, yyyy h:mmaa"
                    dateFormat="MMMM d, yyyy"
                    excludeDates={excDates}
                    onFocus={e => e.target.blur()}
                  ></DatePicker>
                </div>

                {
                  (activeTab === "1") &&
                  <div className="box-form__car-time">
                    <label htmlFor="droptime">
                      <IconCalendarEvent className="input-icon" /> &nbsp; Return Date{" "}
                      <b>*</b>
                    </label>
                    {/* <input
                      id="droptime"
                      value={dropTime}
                      onChange={handleDropTime}
                      type="date"
                      min={new Date().toISOString().split('T')[0]}
                    ></input> */}
                    <DatePicker 
                      id="droptime"
                      selected={endDate}
                      onChange={handleEndDate}
                      minDate={minEndDate}
                      dateFormat="MMMM d, yyyy"
                      excludeDates={excDates}
                      onFocus={e => e.target.blur()}
                    ></DatePicker>
                  </div>
                }

                <button onClick={openModal} type="submit">
                  Search
                </button>
              </form>

              <p className="error-message">
                <span className="error-text">All fields required!</span> <IconX width={20} height={20} onClick={hideMessage}/>
              </p>

              <p className="booking-done">
                Your booking has been processed successfully.{" "}
                <IconX width={20} height={20} onClick={hideMessage} />
              </p>

              <p className="booking-error">
                An error occurred while processing your request. Please try again.{" "}
                <IconX width={20} height={20} onClick={hideMessage} />
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* modal ------------------------------------ */}

      <div className={`booking-modal ${modal ? "active-modal" : ""}`}>
        {/* title */}
        <div className="booking-modal__title">
          <h2>Complete Reservation</h2>
          <IconX onClick={openModal} />
        </div>
        {/* message */}
        <div className="booking-modal__message">
          {/* <h4>
            <IconInfoCircleFilled /> Upon completing this reservation enquiry,
            you will receive:
          </h4>
          <p>
            Your rental voucher to produce on arrival at the rental desk and a customer support number.
          </p> */}
        </div>
        {/* car info */}
        <div className="booking-modal__car-info">
          <div className="dates-div">
            <div className="booking-modal__car-info__dates">
              <h5>Location & Date</h5>
              <span>
                <IconMapPinFilled />
                <div>
                  <h6>Pick-Up Date & Time</h6>
                  <p>
                    {pickTime} /{" "}
                    {/* <input type="time" className="input-time" onChange={handlePickDateTime}></input> */}
                    <DatePicker
                      selected={pickDateTime}
                      onChange={(date) => handlePickDateTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      //timeIntervals={15}
                      timeCaption="Pick-Up Time"
                      dateFormat="h:mm aa"
                      excludeTimes={[
                        setHours(setMinutes(new Date(), 0), 0),
                        setHours(setMinutes(new Date(), 0), 1),
                        setHours(setMinutes(new Date(), 0), 2),
                        setHours(setMinutes(new Date(), 0), 3),
                        setHours(setMinutes(new Date(), 0), 4),
                        setHours(setMinutes(new Date(), 0), 5),
                        setHours(setMinutes(new Date(), 0), 6),
                        setHours(setMinutes(new Date(), 0), 23),

                        setHours(setMinutes(new Date(), 30), 0),
                        setHours(setMinutes(new Date(), 30), 1),
                        setHours(setMinutes(new Date(), 30), 2),
                        setHours(setMinutes(new Date(), 30), 3),
                        setHours(setMinutes(new Date(), 30), 4),
                        setHours(setMinutes(new Date(), 30), 5),
                        setHours(setMinutes(new Date(), 30), 6),
                        setHours(setMinutes(new Date(), 30), 22),
                        setHours(setMinutes(new Date(), 30), 23),
                      ]}
                    />
                  </p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <IconMapPinFilled />
                <div>
                  <h6>Drop-Off Date & Time</h6>
                  <p>
                    {dropTime} /{" "}
                    {/* <input type="time" className="input-time" onChange={handleDropDateTime}></input> */}
                    <DatePicker
                      selected={dropDateTime}
                      onChange={(date) => handleDropDateTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      //timeIntervals={15}
                      timeCaption="Drop-Off Time"
                      dateFormat="h:mm aa"
                      excludeTimes={[
                        setHours(setMinutes(new Date(), 0), 0),
                        setHours(setMinutes(new Date(), 0), 1),
                        setHours(setMinutes(new Date(), 0), 2),
                        setHours(setMinutes(new Date(), 0), 3),
                        setHours(setMinutes(new Date(), 0), 4),
                        setHours(setMinutes(new Date(), 0), 5),
                        setHours(setMinutes(new Date(), 0), 6),
                        setHours(setMinutes(new Date(), 0), 23),

                        setHours(setMinutes(new Date(), 30), 0),
                        setHours(setMinutes(new Date(), 30), 1),
                        setHours(setMinutes(new Date(), 30), 2),
                        setHours(setMinutes(new Date(), 30), 3),
                        setHours(setMinutes(new Date(), 30), 4),
                        setHours(setMinutes(new Date(), 30), 5),
                        setHours(setMinutes(new Date(), 30), 6),
                        setHours(setMinutes(new Date(), 30), 22),
                        setHours(setMinutes(new Date(), 30), 23),
                      ]}
                    />
                  </p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <IconMapPinFilled />
                <div>
                  <h6>Pick-Up Location</h6>
                  <p>{pickUp}</p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <IconMapPinFilled />
                <div>
                  <h6>Drop-Off Location</h6>
                  <p>{dropOff}</p>
                </div>
              </span>
            </div>
          </div>
          <div className="booking-modal__car-info__model">
            <h5>
              <span>Car -</span> {carName} rent for {(numDays>0)? numDays:"a"} {(numDays>1)? "days":"day"} 
            </h5>
            {imgUrl && <img src={imgUrl} alt="car_img" />}
          </div>
        </div>
        {/* personal info */}
        <div className="booking-modal__person-info">
          <h4>Personal Information</h4>
          <form ref={bookform} className="info-form">
            <div className="info-form__2col">
              <span>
                <label>
                  First Name <b>*</b>
                </label>
                <input
                  value={name}
                  onChange={handleName}
                  type="text"
                  placeholder="Enter your first name"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Last Name <b>*</b>
                </label>
                <input
                  value={lastName}
                  onChange={handleLastName}
                  type="text"
                  placeholder="Enter your last name"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>

              <span>
                <label>
                  Phone Number <b>*</b>
                </label>
                <input
                  value={phone}
                  onChange={handlePhone}
                  type="tel"
                  placeholder="Enter your phone number"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              {/* <span>
                <label>
                  Age <b>*</b>
                </label>
                <input
                  value={age}
                  onChange={handleAge}
                  type="number"
                  placeholder="18"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div>

            <div className="info-form__1col">
              <span>
                <label>
                  Email <b>*</b>
                </label>
                <input
                  value={email}
                  onChange={handleEmail}
                  type="email"
                  placeholder="Enter your email address"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span> */}

              {/* <span>
                <label>
                  Address <b>*</b>
                </label>
                <input
                  value={address}
                  onChange={handleAddress}
                  type="text"
                  placeholder="Enter your street address"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span> */}
            </div>

            {/* <div className="info-form__2col">
              <span>
                <label>
                  City <b>*</b>
                </label>
                <input
                  value={city}
                  onChange={handleCity}
                  type="text"
                  placeholder="Enter your city"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Zip Code <b>*</b>
                </label>
                <input
                  value={zipcode}
                  onChange={handleZip}
                  type="text"
                  placeholder="Enter your zip code"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div> */}

            <div className="info-form__1col">
              <span>
                <label>
                  Discount Coupon
                </label>
                <input
                  value={discountcode}
                  onChange={handleDiscount}
                  type="text"
                  placeholder="Enter your discount code"
                ></input>
              </span>
            </div>

            <span className="info-form__checkbox">
              <input type="checkbox" onChange={handleCityOnly} checked={cityonly}></input>
              <p>Use the vehicle within the city only</p>
            </span>

            <span className="info-form__checkbox">
              <input type="checkbox" onChange={handleAcceptTAC}></input>
              <p>I accept the <a href="#" onClick={openTACModal}>terms and conditions</a></p>
            </span>

            <div ref={paypal}></div>   

            {/* <div className="info-form__1col">
              <span>
                <p>- Total fee includes carwash fee (300) and booking fee (30).</p>
                <p>- Late return will be charged EXCESS FEE per hour for a maximum of 4 hours. Over 4 hours will be counted as 1 day.</p>
              </span>
            </div> */}

            <p className="res-error-message">
              <span className="res-error-text">All fields required!</span> <IconX width={20} height={20} onClick={hideMessage}/>
            </p>


            <div className="info-form__1col">
              {processing?
              <span className="loaderbtn"></span>
              :
              <div className="reserve-button">
                <span className="pick-description__total"> 
                  <h5>
                    <ul>
                      <li>
                      Rental Fee: ₱{rentfee}
                      </li>
                      <li>
                      Booking Fee: ₱{bookingfee}
                      </li>
                      <li>
                      Carwash Fee: ₱{carwashfee}
                      </li>
                    </ul>
                  </h5>
                  <p>Total: ₱{totalfee}</p>
                  {(!orderConfirmed) && <button onClick={confirmBooking}>Reserve Now</button>}
                </span>    
                {/* <div id="paypal-container-4K8YMAZFU79BQ"></div>             */}   
              </div>}
            </div>
          </form>
        </div>
      </div>

      <div className={`booking-modal ${TACmodal ? "active-modal" : ""}`}>
        {/* title */}
        <div className="booking-modal__title">
          <h2>Terms And Conditions</h2>
          <IconX onClick={openTACModal} />
        </div>
        {/* message */}
        <div className="booking-modal__message">
            <TermsAndConditions />
        </div>
      </div>
    </>
  );
}

export default BookCar;
